import React, { useState, useEffect } from "react";
import { auth, db } from "./firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  updateProfile,
  sendEmailVerification,
  signOut } from
"firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

const AuthModal = ({ onClose }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [isResetView, setIsResetView] = useState(false);
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [teamQuery, setTeamQuery] = useState("");
  const [selectedTeam, setSelectedTeam] = useState("");
  const [teams, setTeams] = useState([]);
  const [error, setError] = useState("");
  const [resetMessage, setResetMessage] = useState("");
  const [isResetSending, setIsResetSending] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("/teams.json").
    then((res) => res.json()).
    then((data) => {
      setTeams(Object.values(data.teams));
    }).
    catch((err) => console.error("Error loading teams:", err));
  }, []);

  const filteredTeams = teams.filter((team) =>
  team.name.toLowerCase().includes(teamQuery.toLowerCase())
  );

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setResetMessage("");

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      if (!user.emailVerified) {
        setError("Please verify your email before logging in.");
        await signOut(auth);
        return;
      }

      navigate("/starsonata/team");
      onClose();
    } catch (err) {
      console.error(err);
      setError(err.message);
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError("");
    setResetMessage("");
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const uid = userCredential.user.uid;
      const teamName = teams.find((team) => team.teamID === selectedTeam)?.name || "";
      await updateProfile(userCredential.user, { displayName: username });
      await setDoc(doc(db, "users", uid), {
        username,
        email,
        teamId: selectedTeam,
        teamName,
        verified: false,
        role: "member",
        requestedTeamId: null
      });
      await sendEmailVerification(userCredential.user);
      alert("A verification email has been sent. Please check your inbox.");
      navigate("/starsonata/team");
      onClose();

    } catch (err) {
      console.error(err);
      setError(err.message);
    }
  };

  const handleForgotPassword = async () => {
    setError("");
    setResetMessage("");

    if (!email.trim()) {
      setError("Enter your email address first.");
      return;
    }

    try {
      setIsResetSending(true);
      await sendPasswordResetEmail(auth, email.trim());
      setResetMessage("If an account exists for this email, a password reset link has been sent.");
    } catch (err) {
      console.error(err);
      if (err?.code === "auth/invalid-email") {
        setError("Please enter a valid email address.");
      } else if (err?.code === "auth/too-many-requests") {
        setError("Too many reset attempts. Please try again later.");
      } else {
        setError("Unable to send a reset email right now. Please try again.");
      }
    } finally {
      setIsResetSending(false);
    }
  };

  return (
    <div style={styles.overlay}>
            <div style={styles.modal}>
                <button style={styles.closeButton} onClick={onClose}>
                    &times;
                </button>
                <h2 style={styles.heading}>
                  {isResetView ? "Reset Password" : isLogin ? "Login" : "Sign Up"}
                </h2>
                {error && <p style={{ color: "red" }}>{error}</p>}
                {resetMessage && <p style={styles.successMessage}>{resetMessage}</p>}
                <form
          onSubmit={
          isResetView ?
          (e) => {
            e.preventDefault();
            handleForgotPassword();
          } :
          isLogin ?
          handleLogin :
          handleSignUp
          }>
                    {!isResetView && !isLogin &&
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            style={styles.input} />

          }
                    <input
            type="email"
            placeholder={isResetView ? "Enter your account email" : "Email"}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError("");
              setResetMessage("");
            }}
            required
            style={styles.input} />

                    {!isResetView &&
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={styles.input} />
          }

                    {isLogin && !isResetView &&
          <button
            type="button"
            style={styles.forgotPasswordButton}
            onClick={() => {
              setError("");
              setResetMessage("");
              setIsResetView(true);
            }}>

                        Forgot password?
                      </button>
          }
          
                    {!isResetView && !isLogin &&
          <>
                            <input
              type="text"
              placeholder="Search for your team"
              value={teamQuery}
              onChange={(e) => {
                setTeamQuery(e.target.value);
                setSelectedTeam("");
              }}
              required
              style={styles.input} />
            
                            {teamQuery && !selectedTeam && filteredTeams.length > 0 &&
            <ul style={styles.suggestions}>
                                    {filteredTeams.map((team) =>
              <li
                key={team.teamID}
                style={styles.suggestionItem}
                onClick={() => {
                  setSelectedTeam(team.teamID);
                  setTeamQuery(team.name);
                }}>
                
                                            {team.name}
                                        </li>
              )}
                                </ul>
            }
                        </>
          }
                    <button
            type="submit"
            style={styles.button}
            disabled={isResetView ? isResetSending : !isLogin && !selectedTeam}>
                        {isResetView ? isResetSending ? "Sending reset link..." : "Send reset link" : isLogin ? "Login" : "Sign Up"}
                    </button>
                    {isResetView &&
          <button
            type="button"
            style={styles.secondaryButton}
            onClick={() => {
              setIsResetView(false);
              setIsLogin(true);
              setError("");
              setResetMessage("");
            }}>

                        Back to Login
                      </button>
          }
                </form>
                {!isResetView &&
                <button
          onClick={() => {
            setIsLogin(!isLogin);
            setError("");
            setResetMessage("");
          }}
          style={styles.toggleButton}>
          
                    {isLogin ? "Need an account? Sign Up" : "Already have an account? Login"}
                </button>
                }
            </div>
        </div>);

};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.9)",
    backdropFilter: "blur(4px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000
  },
  modal: {
    background: "#fff",
    padding: "30px",
    borderRadius: "10px",
    width: "90%",
    maxWidth: "400px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
    position: "relative"
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "15px",
    fontSize: "1.5rem",
    background: "none",
    border: "none",
    cursor: "pointer"
  },
  heading: {
    marginTop: 0,
    textAlign: "center",
    color: "#333"
  },
  input: {
    display: "block",
    width: "100%",
    padding: "12px 15px",
    margin: "10px 0",
    fontSize: "1rem",
    border: "1px solid #ccc",
    borderRadius: "6px",
    outline: "none",
    transition: "border-color 0.2s",
    boxSizing: "border-box"
  },
  forgotPasswordButton: {
    background: "none",
    border: "none",
    color: "#007bff",
    textDecoration: "underline",
    cursor: "pointer",
    fontSize: "0.9rem",
    padding: 0,
    margin: "4px 0 0 0"
  },

  button: {
    display: "block",
    width: "100%",
    padding: "12px",
    marginTop: "15px",
    fontSize: "1rem",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "background-color 0.2s",
    boxSizing: "border-box"
  },
  secondaryButton: {
    display: "block",
    width: "100%",
    padding: "12px",
    marginTop: "10px",
    fontSize: "1rem",
    backgroundColor: "#f3f3f3",
    color: "#333",
    border: "1px solid #ccc",
    borderRadius: "6px",
    cursor: "pointer",
    boxSizing: "border-box"
  },
  suggestions: {
    listStyle: "none",
    padding: 0,
    margin: "5px 0",
    border: "1px solid #ccc",
    borderRadius: "4px",
    background: "#fafafa",
    maxHeight: "150px",
    overflowY: "auto"
  },
  suggestionItem: {
    padding: "10px",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
    color: "#333"
  },
  toggleButton: {
    marginTop: "20px",
    background: "none",
    border: "none",
    color: "#007bff",
    cursor: "pointer",
    textDecoration: "underline",
    width: "100%",
    fontSize: "0.9rem"
  },
  successMessage: {
    color: "green",
    textAlign: "center",
    fontSize: "0.9rem",
    margin: "0 0 10px"
  }
};

export default AuthModal;
